import { IRequestOptions } from 'repositories/HttpClientRepository/interfaces';
import { HttpClientRepository } from 'repositories/HttpClientRepository';
import SessionStore from 'store/Session/Session.store';
import {
    DEFAULT_LOCALE,
    LOCALE_HEADER_NAME,
    PARTNER_CODE_HEADER_NAME,
    TIMEZONE_HEADER_NAME,
} from 'constants/constants';
import { IHeaderDecorator } from './interfaces/IHeaderDecorator';

export default class HeaderDecorator implements IHeaderDecorator {
    private partnerCode: string;

    private buildRequestOptions = <P>(requestOptions: IRequestOptions<P>): IRequestOptions<P> => ({
        ...requestOptions,
        options: {
            headers: {
                ...requestOptions?.options?.headers,
                ...this.getHeaders(),
            },
        },
    });

    constructor(
        private readonly sessionStore: SessionStore,
        private readonly httpClient: HttpClientRepository,
    ) {}

    public getHeaders(): Record<string, string> {
        return {
            [LOCALE_HEADER_NAME]: this.sessionStore.language || DEFAULT_LOCALE,
            [PARTNER_CODE_HEADER_NAME]: this.partnerCode || '-',
            [TIMEZONE_HEADER_NAME]: this.sessionStore.session.timezone || '0',
        };
    }

    public get = <T = unknown, P = unknown>(
        url: string,
        requestOptions: IRequestOptions<P> = {},
    ): Promise<T> => this.httpClient.get(url, this.buildRequestOptions<P>(requestOptions));

    public post = <T = unknown, P = unknown>(
        url: string,
        requestOptions: IRequestOptions<P> = {
            transformRequest: true,
        },
    ): Promise<T> => this.httpClient.post(url, this.buildRequestOptions<P>(requestOptions));

    public remove = <T = unknown, P = Record<string, unknown>>(
        url: string,
        requestOptions: IRequestOptions<P> = {},
    ): Promise<T> => this.httpClient.remove(url, this.buildRequestOptions<P>(requestOptions));

    public setApiUrl = (apiUrl: string): void => {
        this.httpClient.setApiUrl(apiUrl);
    };

    public setPartnerCode = (partnerCode: string) => {
        this.partnerCode = partnerCode;
    };
}
